// extracted by mini-css-extract-plugin
module.exports = {"vanlife-roadtrips-G":"G_vanlife-roadtrips-G__ad2N1"};